export const DEFAULT_TESTIMONIALS = [
  {
    quote:
      "I enjoyed learning both in CS50 and CS50AI. The instructors were awesome and I intend to return for more learning.",
    author: "edX online learner",
  },
  {
    quote:
      "I enjoyed CS50 web and learned a lot. I will certainly use this certificate when getting internship.",
    author: "edX online learner",
  },
  {
    quote: "CS50 changed my life! It is incredible!",
    author: "edX online learner",
  },
];

export const DEFAULT_AUTHOR = "edX online learner";
